import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { RenameFileInput, RenameFileMutation } from '@/gql/graphql';

const RENAME_FILE = graphql(`
  mutation RenameFile($input: RenameFileInput!) {
    renameFile(input: $input) {
      id
      fileName
    }
  }
`);

const useRenameFile = (
  options?: UseMutationOptions<RenameFileMutation, unknown, RenameFileInput>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(RENAME_FILE, { input });
    },
    ...options,
  });
};

export default useRenameFile;
